import { render, staticRenderFns } from "./SendMessageDetailTab.vue?vue&type=template&id=157000c0&scoped=true&lang=pug"
import script from "./SendMessageDetailTab.vue?vue&type=script&lang=ts"
export * from "./SendMessageDetailTab.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageDetailTab.vue?vue&type=style&index=0&id=157000c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157000c0",
  null
  
)

export default component.exports